var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from 'react';
import useAdditionalParameters from '../hooks/useAdditionalParameters';
import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
import { doesXPathExist, execJsInSdk, getEdgeSessionStorageItem, } from '../integration-utils';
import { postParentWindowMessage } from '../../../../utils/post-message';
import { useAppSelector } from '../../../../state';
import { selectDevicePlatform } from '../../../../state/slices/slice-link-params';
var referrerScript = "\n    var metaReferrer = document.createElement('meta');\n    metaReferrer.name = 'referrer';\n    metaReferrer.content = 'origin';\n    document.getElementsByTagName('head')[0].appendChild(metaReferrer);\n  ";
export function useDoorDash() {
    var _this = this;
    var _a = useState(false), loaded = _a[0], setLoaded = _a[1];
    var addAdditionalParameters = useAdditionalParameters().addAdditionalParameters;
    var devicePlatform = useAppSelector(selectDevicePlatform) || 'ios';
    // Poll the webview for a xpath once the DOM is loaded.
    useEffect(function () {
        if (!loaded)
            return function () { };
        if (devicePlatform !== 'android') {
            // eslint-disable-next-line no-new-func
            void execJsInSdk(new Function(referrerScript));
        }
        var interval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var result, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, doesXPathExist('//*[contains(text(), "Verifying...")]')];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 4];
                        // If we return too quickly, the Persona request may not fully send if
                        // the user has a slow connection
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2500); })];
                    case 2:
                        // If we return too quickly, the Persona request may not fully send if
                        // the user has a slow connection
                        _a.sent();
                        return [4 /*yield*/, getEdgeSessionStorageItem('inquiry:access-token')];
                    case 3:
                        accessToken = _a.sent();
                        addAdditionalParameters({ accessToken: accessToken });
                        postParentWindowMessage({
                            type: 'PINWHEEL_INTERNAL_COMM_UP',
                            eventName: 'setos_request',
                        });
                        clearInterval(interval);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, [addAdditionalParameters, loaded, devicePlatform]);
    // Memoize callback as `useCheckLoadedAndShow` has it as a useEffect dependency
    var callback = useCallback(function () {
        setLoaded(true);
    }, []);
    useCheckLoadedAndShow(callback);
}
